module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_3009.776e8e87.png";